import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '明星动态', to: '/stars' },
  { label: '关于我们', to: '/about' },
];

const friendLinks = ['影视观察周刊', '剧集研究社', '影像档案室', '银幕笔记'];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-500 text-background-50">
      <div className="w-full px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-primary-600">
                <i className="ri-moon-clear-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide">无颜的月</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-50/75">
              专注影视作品资讯、剧情介绍与明星动态，覆盖电影与电视剧资源，陪你发现每一部值得追的好作品。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">网站导航</h3>
            <ul className="mt-4 space-y-2">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-background-50/75 transition-colors hover:text-accent-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">友情链接</h3>
            <ul className="mt-4 space-y-2">
              {friendLinks.map((l) => (
                <li key={l}>
                  <a
                    href="#"
                    className="text-sm text-background-50/75 transition-colors hover:text-accent-300"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">联系我们</h3>
            <ul className="mt-4 space-y-2 text-sm text-background-50/75">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base" />
                <span>hello@wuyandeyue.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base" />
                <span>400-888-0723</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base" />
                <span>北京市朝阳区影视产业园 8 号</span>
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-3">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/15 text-background-50">
                <i className="ri-wechat-line text-base" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/15 text-background-50">
                <i className="ri-weibo-line text-base" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/15 text-background-50">
                <i className="ri-video-line text-base" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-50/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 无颜的月 影视内容站 · 本站内容均为虚构演示数据，仅供展示</p>
          <p>播放与下载功能为前端演示入口，不提供真实资源</p>
        </div>
      </div>
    </footer>
  );
}